export const onDialogAddDoneModel = model => ({
  widget: 'models',
  type: 'onDialogAddDoneModel',
  payload: { model },
})



// WEBPACK FOOTER //
// ./src/models/actions/onDialogAddDoneModel.js